import WebShadowButton from "../../../WebStoryScreen/Components/WebShadowButton";
import "./SessionModal.scss";

interface SessionModalProps {
  variant: "breathe" | "guided";
  onEndSession: () => void;
  onContinue: () => void;
}

function SessionModal({
  variant,
  onEndSession,
  onContinue,
}: SessionModalProps) {
  return (
    <div className="session-modal__overlay">
      <div className="session-modal__actions">
        <WebShadowButton
          variant="outline"
          title={"End session"}
          onPress={onEndSession}
          className="session-modal__end-btn"
        />
        <WebShadowButton
          title={variant === "guided" ? "Play Again" : "Continue for 1 minute"}
          onPress={onContinue}
          className="session-modal__continue-btn"
        />
      </div>
    </div>
  );
}

export default SessionModal;
